export enum RequirementTypeEnum {
    PASSPORT,
    SELFIE,
    POA,
}

export type RequirementsProps = {
    onBack: () => void;
    type: RequirementTypeEnum;
};
